export const formatMinutes = (totalMinutes) => {
  const m = totalMinutes || 0;
  const h = Math.floor(m / 60);
  const min = m % 60;
  
  return h > 0 ? `${h}시간 ${min}분` : `${min}분`;
};

export const formatDecimalToHours = (decimalHours) => {
  const total = Number(decimalHours) || 0;
  const hours = Math.floor(total);
  const minutes = Math.round((total - hours) * 60);

  // 60분이 되는 경우(예: 1.99 -> 2.0) 대비
  if (minutes === 60) return `${hours + 1}h 0m`;
  
  return minutes > 0 ? `${hours}시간 ${minutes}분` : `${hours}시간`;
};